import { render, staticRenderFns } from "./snackbarcomp.vue?vue&type=template&id=7d168036&"
import script from "./snackbarcomp.vue?vue&type=script&lang=js&"
export * from "./snackbarcomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports